/**
 * echarts按需引入，但目前5.1.2的版本按需引入有问题，还是会全量加载，先留个口，后续升级再看
 * 用babel-plugin-import（babel-plugin-equire只支持旧版的echarts按需引入）
 */
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口
import * as echarts from 'echarts/core';
// 引入具体使用图表，后缀都为 Chart
import {
  BarChart, // 柱状图
  LineChart, // 折线图
  PieChart // 饼图
} from 'echarts/charts';
// 引入组件，后缀都为 Component
import {
  TitleComponent, // 标题
  TooltipComponent, // 提示框
  GridComponent, // 直角坐标系
  LegendComponent, // 图例
  TransformComponent, // 数据转换
  ToolboxComponent, // 工具栏
  AxisPointerComponent, // 坐标轴指示器
  DataZoomComponent, // 缩放
  DataZoomInsideComponent, // 内置缩放组件
  DataZoomSliderComponent, // 滑动条型缩放组件
  VisualMapComponent, // 数据视觉映射
  VisualMapContinuousComponent, // 连续型
  VisualMapPiecewiseComponent, // 分段型
  MarkPointComponent, // 图表标注
  MarkLineComponent, // 图表标线
  MarkAreaComponent, // 图表标域
  GraphicComponent // 图形元素组件
} from 'echarts/components';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers';

// 注册必须的组件
echarts.use([
  BarChart,
  LineChart,
  PieChart,
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  TransformComponent,
  ToolboxComponent,
  AxisPointerComponent,
  DataZoomComponent,
  DataZoomInsideComponent,
  DataZoomSliderComponent,
  VisualMapComponent,
  VisualMapContinuousComponent,
  VisualMapPiecewiseComponent,
  MarkPointComponent,
  MarkLineComponent,
  MarkAreaComponent,
  CanvasRenderer,
  GraphicComponent
]);

export default echarts;
